import axios from 'axios';
import { ability } from '@oliasoft/authorization-ui';
import { FeatureFlags } from '@oliasoft/feature-flags';

import ClientConfig from 'client/config';
import { TCommonTableCell } from 'common/interfaces/objects-interfaces';
import { getAccessToken } from './store/middleware/api/api';

export const downloadBlob = (url: string, fileName: string) => {
  const a = window.document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

export const getAbilities = async () => {
  const response = await axios({
    method: 'GET',
    baseURL: ClientConfig.config.owaApiUrl,
    url: '/auth',
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
    },
  });

  ability.update(response?.data?.ability);

  const { enableAllFlags, activeFlags, disabledFlags } = ClientConfig.config.featureFlags;
  FeatureFlags.init({
    flags: response?.data?.featureFlags, enableAllFlags, activeFlags, disabledFlags,
  });
};

// Do not pass this via redux blob data should not be serilized
export const getRawBlob = (blobName: string) => axios.request({
  url: `/object/raw?blobName=${blobName}`,
  method: 'GET',
  responseType: 'blob',
  baseURL: ClientConfig.config.owaApiUrl,
  headers: {
    Authorization: `Bearer ${getAccessToken()}`,
  },
});

export const stripMongoProperties = <T>(data: T): Omit<T, '__v' | '_id'> => {
  // @ts-ignore
  const { __v, _id, ...restData } = data;
  return restData;
};

// Should we put it in store? Probably not will be used in one place only
// Move also with next endpoint
export const getAllArchives = async () => {
  const response = await axios.request({
    url: '/archive/all',
    method: 'GET',
    baseURL: ClientConfig.config.owaApiUrl,
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
    },
  });
  return response?.data;
};

export const generatePreSignedUrl = async (objectId: string) => {
  const response = await axios.request({
    url: `/object/${objectId}/share`,
    method: 'POST',
    data: { objectId },
    baseURL: ClientConfig.config.owaApiUrl,
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
    },
  });
  return response?.data;
};

export const getSharedObjectUrl = async (preseginedUrl: string) => {
  const response = await axios.request({
    url: `/object/shared/${preseginedUrl}`,
    method: 'GET',
    baseURL: ClientConfig.config.owaApiUrl,
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
    },
  });
  return response?.data;
};

export const getSharedObject = async (preseginedUrl: string) => {
  const response = await axios.request({
    method: 'GET',
    url: preseginedUrl,
    baseURL: '/',
  });
  return response?.data;
};

export const getExcelObject = async (objectId: string, isVerticalTable: boolean, formattedTable?: TCommonTableCell[][]) => {
  const response = await axios.request({
    url: `/object/${objectId}/excel?isVerticalTable=${isVerticalTable}`,
    method: 'POST',
    responseType: 'blob',
    baseURL: ClientConfig.config.owaApiUrl,
    data: { data: formattedTable },
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
    },
  });
  const name = response.headers?.filename;
  const url = URL.createObjectURL(response.data);
  downloadBlob(url, name);
};

export const getEntityChildren = async (entityType: string, entityId: string) => {
  const response = await axios.request({
    method: 'GET',
    url: `/archive/children?type=${entityType}&parentid=${entityId}`,
    baseURL: ClientConfig.config.owaApiUrl,
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
    },
  });
  return response?.data;
};

export const getQueryResultExcel = async (data: any) => {
  const response = await axios.request({
    url: '/query/result-excel',
    method: 'POST',
    responseType: 'blob',
    baseURL: ClientConfig.config.owaApiUrl,
    data,
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
    },
  });
  const name = response.headers?.filename;
  const url = URL.createObjectURL(response.data);
  downloadBlob(url, name);
};
